<template>
  <div>
    <div class="radio-form-item__top-content">
      <div>
        <h4>Zulassung durch PKW.de</h4>
        <p class="radio-form-item__price">€ {{ price }} ,-</p>
      </div>
      <p>PKW.de soll das Fahrzeug für eine einmalige Pauschale von {{ price }} € für mich zulassen.</p>
    </div>
    <ul class="check-list">
      <li>inkl. 2 Kennzeichenschilder</li>
      <li>inkl. Feinstaubplakette</li>
      <li>inkl. Versandkosten & Amtsgebühren</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['order'],
  computed: {
    privateBuyer() {
      return (this.order.private_buyer ? 'private' : 'comercial') || '';
    },
    commercialBuyer() {
      return this.privateBuyer == 'comercial';
    },
    price() {
      if (this.commercialBuyer) {
        return this.order.car_info.online_offer_services.all_services_b2b.registration.standard_with_license_plate
      }
      return this.order.car_info.online_offer_services.all_services.registration.standard_with_license_plate
    },
    
  },
};
</script>
